import { render, staticRenderFns } from "./NewsflashesSection.vue?vue&type=template&id=2bd344e4"
import script from "./NewsflashesSection.vue?vue&type=script&lang=js"
export * from "./NewsflashesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports